export { SemanticBadge, type SemanticBadgeName } from './semantic-badge';

export const UNKNOWN_STATUS = 'unknown' as const;
